<app-shared-dialog
  [title]="'smart_inbox.compose.placeholders_dialog.title' | translate"
  [options]="{
    hideHeader: true,
    hideCloseButton: true,
    customConfirmButton: true,
    size: 'medium'
  }">
  <div class="placeholders-confirm">
    
    <span class="placeholders-confirm__title"> <mat-icon class="placeholders-confirm__icon">warning_amber</mat-icon> {{ 'smart_inbox.compose.placeholders_dialog.title' | translate }}</span>
    <p class="placeholders-confirm__description">{{ 'smart_inbox.compose.placeholders_dialog.description' | translate }}</p>
    <div class="placeholders-confirm__list-container">
      <ul class="placeholders-confirm__list">
        <li *ngFor="let p of data.placeholders"><b>{{ p.id }}</b>{{ p.description ? ' — ' + p.description : '' }}</li>
      </ul>
    </div>
    <p class="placeholders-confirm__footer">{{ 'smart_inbox.compose.placeholders_dialog.footer' | translate }}</p>
  </div>
  
  <div customConfirm class="placeholders-confirm__actions">
    <ui-button  
      type="secondary"
      [label]="'smart_inbox.compose.placeholders_dialog.go_back' | translate"
      (click)="goBack()">
    </ui-button>
    <ui-button
      type="warning"
      [label]="'smart_inbox.compose.placeholders_dialog.send_anyway' | translate"
      (click)="sendAnyway()">
    </ui-button>
  </div>
</app-shared-dialog>
